/**
 * 校验表单
 */
import Validation from './rules'

const ValidatePlugin = {}
ValidatePlugin.install = function (Vue, options) {
  if (!ValidatePlugin.validation) {
    ValidatePlugin.validation = new Validation()
  }

  Vue.directive('blur-validate', {
    inserted(el, binding, vNode) {
      const { arg, value } = binding
      const { rules, handleStyles } = ValidatePlugin.validation
      // 保存 vm 实例
      if (!ValidatePlugin.validation._vm) {
        ValidatePlugin.validation._vm = vNode.context
      }
      function handleFun (el, vNode) {
        // console.log(el.name)
        const elName = el.name
        for (let i = 0; i < value.length; i++) {
          const result = handleStyles[arg](rules[value[i]], el, vNode)
          if (result.pass) {
            ValidatePlugin.validation.delErrorObj(elName)
          } else {
            if (!ValidatePlugin.validation.errorObj[elName]) {
              ValidatePlugin.validation.addErrorObj(elName, el, result.msg)
              return
            } else {
              ValidatePlugin.validation.errorObj[elName].msg = result.msg
            }
          }
        }
      }
      el.addEventListener('blur', handleFun.bind(vNode.context, el, vNode), false)
      el.addEventListener('focus', handleStyles['textNormal'].bind(vNode.context, el, vNode), false)
    }
  })
  Vue.directive('check-submit', {
    inserted(el, binding, vNode) {
      el.addEventListener('click', e => {
        e.preventDefault()
        // 清空错误列表
        ValidatePlugin.validation.resetErrorObj()
        const form = vNode.context.$refs[binding.arg]
        if (!form) {
          console.warn('请传入包裹表单元素容器的引用')
          return
        }
        let elements = form.getElementsByTagName('input')
        const evObj = document.createEvent('Event')
        evObj.initEvent('blur', true, true)
        for (let element of elements) {
          element.dispatchEvent(evObj)
        }
        let errorInputs = form.getElementsByClassName('check-error')
        if (errorInputs.length === 0) {
          binding.value()
        } else {
          const firstErrEl = errorInputs[0].getElementsByTagName('input')[0]
          // const errorKey = errorInputs[0].getElementsByTagName('input')[0].name
          ValidatePlugin.validation._vm.$toast(ValidatePlugin.validation.errorObj[firstErrEl.name].msg)
          // 第一个元素滚动到可视区
          document.documentElement.scrollTop = firstErrEl.offsetTop - document.documentElement.clientHeight + 100
        }
      })
    },
    unbind() {
      // 还原校验对象
      ValidatePlugin.validation = new Validation()
    }
  })
}

export default ValidatePlugin



// WEBPACK FOOTER //
// ./src/plugins/validate/index.js